import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledProgressDetail = styled.div`
  .progress-item {
    display: flex;
    align-items: center;
    padding: 5px 0px;
    gap: 10px;
    border-bottom: 1px solid ${Colors.border};

    &:last-child {
      border-bottom: none;
    }

    .numbers {
      display: flex;
      align-items: center;
      gap: 10px;

      .ant-statistic-content {
        white-space: nowrap;
      }
    }

    .answers {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
    }

    .date-container {
      display: flex;
      flex-direction: column;

      .date {
        display: flex;
        align-items: center;
        gap: 5px;
      }

      .time {
        font-size: 13px;
      }

      .info {
        cursor: pointer;
      }
    }
  }
`;
